export default __webpack_public_path__ + "static/media/sandal6.5de7a449.jpeg";